<script>
import { Doughnut } from "vue-chartjs";
import * as soluhaApi from "@/soluhaApi";
const emptyStatePlugin = {
  afterDraw: function (chart) {
    if (chart.data.datasets[0].data.every((item) => item === 0)) {
      let ctx = chart.chart.ctx;
      let width = chart.chart.width;
      let height = chart.chart.height;

      chart.clear();
      ctx.save();
      ctx.font = "12px Poppins, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#A0A3BD";
      ctx.fillText("Tidak ada data", width / 2, height / 2);
      ctx.restore();
    }
  },
};
export default {
  extends: Doughnut,
  props: ["divisi", "tanggal", "cabang"],
  data() {
    return {
      chartData: {
        labels: ["Hadir", "Sakit, Izin", "Alpha"],
        datasets: [
          {
            label: "My First Dataset",
            data: [300, 50, 100],
            backgroundColor: ["#FFB700", "#F37D34", "#EB5757"],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  watch: {
    divisi: function (newVal, oldVal) {
      this.getPresensi(newVal, this.tanggal, this.cabang);
    },

    tanggal: function (newVal, oldVal) {
      this.getPresensi(this.divisi, newVal, this.cabang);
    },

    cabang: function (newVal, oldVal) {
      this.getPresensi(this.divisi, this.tanggal, newVal);
    },
  },

  methods: {
    async getPresensi(divisi, tanggal, cabang) {
      let date = new Date(tanggal);
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      // ambil date start dan date end
      let dateStart = new Date(year, month, day);
      let dateEnd = new Date(year, month, day + 1);
      // ambil data dari api
      let dataPresensi = await soluhaApi.getGrafikPresensi(
        dateStart.getTime(),
        dateEnd.getTime(),
        divisi,
        cabang
      );
      this.chartData.datasets[0].data[0] = dataPresensi.totalPresensi;
      this.chartData.datasets[0].data[1] = dataPresensi.totalIzin;
      this.chartData.datasets[0].data[2] = dataPresensi.totalAlpha;
      // render chart
      this.renderChart(this.chartData, this.options);
    },
  },

  mounted() {
    // add plugin
    this.addPlugin(emptyStatePlugin);
    this.getPresensi(this.divisi, this.tanggal, this.cabang);
  },
};
</script>
